/** packages/mouse-management/src/pages/dpiSetting/types.ts — DPI 页共享类型 */

export interface DpiColor {
  r: number;
  g: number;
  b: number;
}

export interface DpiProfile {
  id: number;
  enabled: boolean;
  xValue: number;
  yValue: number;
  color: DpiColor;
  xyIndependent: boolean;
  label: string;
}

export const colorToHex = (c: DpiColor): string => {
  const toHex = (n: number) =>
    Math.max(0, Math.min(255, Math.round(n)))
      .toString(16)
      .padStart(2, "0");
  return `#${toHex(c.r)}${toHex(c.g)}${toHex(c.b)}`;
};

export const hexToColorObj = (hex: string): DpiColor => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
  if (!result) return { r: 255, g: 255, b: 255 };
  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  };
};
